import {Navigate, Outlet, useLocation} from "react-router-dom";
import React from "react";
import {termsService} from "../services/terms.service";

const ConsentRequiredGuard = () => {
    const location = useLocation();
    const requiredConsent = termsService.getPendingEulaVersion() !== null;

    if (requiredConsent) return <Navigate to="/eula" replace state={{from: location}} />;
    return <Outlet />;
};

export default ConsentRequiredGuard;